import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function NoResult(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "NoResult", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M3.454 9h6.73c.522 0 1.005.29 1.263.759l1.018 1.846c.161.292.394.534.675.703.282.17.601.258.927.258h20.45c.69 0 1.25.577 1.25 1.29v23.29c0 1.165-.916 2.11-2.045 2.11H4.046c-1.13 0-2.046-.945-2.046-2.11V10.5C2 9.67 2.651 9 3.454 9Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M33.932 15.332H3.836C2.822 15.332 2 16.18 2 17.226v5.645c0 1.046.822 1.894 1.836 1.894h30.096c1.014 0 1.835-.848 1.835-1.894v-5.645c0-1.046-.822-1.894-1.835-1.894Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M33.932 18.141H3.836C2.822 18.141 2 18.99 2 20.035v3.495c0 1.046.822 1.894 1.836 1.894h30.096c1.014 0 1.835-.848 1.835-1.894v-3.495c0-1.046-.822-1.894-1.835-1.894Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M2 37.145V22.934c0-1.22.958-2.208 2.14-2.208h29.488c1.182 0 2.14.989 2.14 2.208v14.211c0 1.166-.916 2.11-2.046 2.11H4.046c-1.13 0-2.046-.944-2.046-2.11Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M39.843 33.651a.56.56 0 0 1-.396-.164l-5.602-5.603a.56.56 0 0 1 .792-.792l5.602 5.603a.56.56 0 0 1-.396.956Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27.517 32.53c6.498 0 11.766-5.267 11.766-11.765S34.015 9 27.517 9c-6.497 0-11.765 5.268-11.765 11.765 0 6.498 5.268 11.766 11.765 11.766Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27.519 30.29a9.524 9.524 0 1 0 0-19.05 9.524 9.524 0 0 0 0 19.05Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m38.51 34.17 4.58 4.585a1.706 1.706 0 0 0 2.412 0 1.706 1.706 0 0 0 0-2.41l-4.584-4.583a1.19 1.19 0 0 0-1.684 0l-.728.729a1.19 1.19 0 0 0 .003 1.68Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M28.128 27.171a1.418 1.418 0 1 0 2.796.476 1.418 1.418 0 0 0-2.796-.476Zm4.156-10.321a.996.996 0 0 1 .655-.752.973.973 0 0 1 1.195.587c.061.203 1.722 5.376-1.537 8.753-.351.372-.973.362-1.345.011-.372-.35-.362-.972-.01-1.344 2.495-2.548 1.11-6.812 1.118-6.858a.537.537 0 0 1-.076-.397Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M25.072 17.025c.476-.457 1.513-1.115 2.855-1.115 1.703 0 2.95 1.146 2.95 2.76 0 1.613-1.476 2.388-1.761 2.526l-.029.552c0 .112-.04.22-.111.3a.363.363 0 0 1-.27.125h-1.37a.363.363 0 0 1-.268-.125.452.452 0 0 1-.112-.3l-.067-1.327c0-.127.095-.191.229-.233.637-.202 1.19-.627 1.19-1.094 0-.371-.248-.636-.667-.636-.447 0-.97.307-1.304.594a.37.37 0 0 1-.218.095c-.124 0-.229-.074-.305-.19l-.837-1.349a.53.53 0 0 1-.076-.265c0-.138.076-.223.17-.318Zm1.808 6.792c0-.17.133-.319.285-.319h1.713c.152 0 .286.149.286.319v1.486c0 .17-.134.318-.286.318h-1.713c-.152 0-.285-.148-.285-.318v-1.486Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
NoResult.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "NoResult"
};
validateTidalLicense();
export {
  NoResult
};
//# sourceMappingURL=NoResult.js.map
